<template>
     <div>



      <div
      style="background-color:rgb(249, 250, 250);height: 40px;
      display: flex;justify-content: space-around;align-items: center;
      color: rgb(134, 123, 228);
      border-bottom:1px solid rgb(202, 196, 196);
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 99;
      min-width: 320px;
      max-width: 540px;
      " 
      >
  
    <!-- <div  @click = "tiao('/')"  style="height: 100%;display: flex;align-items: center;">
           <a>提交报名</a>
          </div> -->
      <div  @click = "tiao('/getdata')"  style="height: 100%;display: flex;align-items: center;">
        <a>查看数据</a>
      </div>
      <!-- <div @click = "tiao('/yuyuemanage')"  style="height: 100%;display: flex;align-items: center;">
        <a>查看预约</a>
     </div>   -->


      <div @click = "exitlogin"  style="height: 100%;display: flex;align-items: center;">
          <a>退出登录</a>
       </div>  
    </div>

<div style="height: 20px;"></div>

    <keep-alive>
      <router-view/>
    </keep-alive>



  </div>
</template>

<script>
import UpdatePage from '@/manage/UpdatePage'
import {Howl, Howler} from 'howler';
var sounds = new Howl({
  src: ['./static/点击.mp3'],
  volume: 0.1
});
  import axios from '@/js/axios.js'
  import {mapMutations,mapGetters} from 'vuex'
  import NavBar from '@/components/navbar/NavBar';
  import NavBarItem from '@/components//navbar/NavBar-item'
  export default {
    name: 'First',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    components:{NavBar,NavBarItem,UpdatePage},

    methods:{
      ...mapMutations(['updatedatas']),
      playaudio(){

        sounds.play();


              },
              exitlogin(){
				axios.post('/logins/exitlogin').then(res=>{

					this.$router.push('/login');
				})
			},
      tiao(e){
       if(e===this.$route.path){
        return;
       }
        
        this.$router.push(e);
        
       
      }

    },
    beforeRouteUpdate(to,from,next){
     
      next();
    }
  }
</script>

<style>
   .slide-fade-enter{
      transform: translateX(340px);
       opacity: 0;
       /* background-color: #0094de; */
   }


  .slide-fade-leave-to
  {
transform: translateX(-340px);
    opacity: 0;
  }


.slide-fade-enter-active{
  transition: all .8s ease;

}
  .slide-fade-leave-active
  {
    transition: all .1s ease;
  }



</style>



// WEBPACK FOOTER //
// src/manage/first.vue